<template>
  <!-- 底部 -->
  <div class="bg-primary c-fff">
    <!-- 电脑端、手机端-->
    <div class="footer">
      <el-row justify="space-between" type="flex" class="f-wrap">
        <el-col :span="24" :md="{ 'span': 6 }">
          <div class="title-1">联系我们</div>
          <div class="title-2 ma-t-30">
            <i class="el-icon-phone-outline"></i> 咨询专线：
          </div>
          <div class="pa-l-20 ma-t-10">021-57163968</div>
          <div class="pa-l-20 ma-t-10">021-57162065</div>
          <div class="title-2 ma-t-30">
            <i class="el-icon-location-outline"></i> 古园地址：
          </div>
          <div class="pa-l-20 ma-t-10">上海市奉贤区海古路755号</div>
        </el-col>

        <el-col :span="24" :md="{ 'span': 11, 'pull': 1 }" class="flex f-center hidden-sm-and-down">
          <img src="@/assets/img/logo-white.png" alt="" srcset="" width="100%" />
        </el-col>

        <el-col :xs="{ span: 21 }" :md="{ span: 6 }">
          <!-- <div class="title-1">服务热线</div>
          <div class="title-0 ma-t-30">021- 8008 201 441</div> -->
          <div class="flex f-between ma-t-30">
            <div class="flex_center">
              <img src="@/assets/img/QR01.jpg" width="100px" height="100px" alt="" srcset="" />
              <div>古园官方微信</div>
            </div>
            <div class="flex_center">
              <img src="@/assets/img/QR02.jpg" width="100px" height="100px" alt="" srcset="" />
              <div>古园官方商城</div>
            </div>

          </div>
        </el-col>
      </el-row>
      <div class="beian">
        <a href="https://beian.miit.gov.cn/" target="_blank" class="c-fff">
          <span>Copyright 2008 滨海古园 沪 ICP 备10003723号-1</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    msg: String,
  },
  data() {
    return {
      isShowS: {
        //footer
        isShowIcon: 0,
      },
      menuData: [],
    };
  },
  created() { },
  methods: {
    toPath(path) {
      if (path != this.activePath) {
        this.$router.replace(path);
      }
    },
  },
  computed: {
    //当前页面path
    activePath() {
      return this.$route.path;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer {
  width: 1280px;
  padding-left: calc(50% - 640px);
  padding-right: calc(50% - 640px);
  height: 400px;
  padding-top: 100px;
  background: url("../assets/img/cloud.png") no-repeat;
  background-size: 80% auto;
  background-position: center;
}

.flex_center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50%;
}

.title-0 {
  font-size: 30px;
  font-weight: 600;
}

.title-1 {
  font-size: 24px;
  font-weight: 600;
}

.title-2 {
  font-size: 20px;
  font-weight: 600;
}

.beian {
  text-align: center;
  margin-top: 100px;
}

// 手机端
@media only screen and (max-width: 992px) {
  .footer {
    width: 90%;
    padding: 20px 0;
    height: auto;
    margin: 0 auto;
  }

  .footer div {
    margin: 0;
    padding: 0;
    line-height: 30px;

    img {
      width: 45%;
      height: auto;
    }
  }

  .title-0 {
    font-size: 14px;
  }

  .title-1 {
    font-size: 14px;
    margin-top: 40px;
  }

  .title-2 {
    font-size: 14px;
  }
}
</style>
